<template>
  <div style="height: calc(100vh - 196px);">
    <vxe-toolbar id="toolbarId" :custom="{storage: true}" export :refresh="{query: RefreshList}">
      <template v-slot:buttons>
        <el-button
          @click="funcFilter"
        >
          查询
        </el-button>
        <el-button v-if="!parentData.isDetail" @click="funcAdd('add')">
          新增
        </el-button>
        <el-button @click="funcExport">
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      show-footer
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="80%"
      :data="tableData"
      sort-config.remote
      :sort-config="{ remote: true }"
      export-config
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" />
      <vxe-table-column>
        <vxe-table-column field="serialNum" title="合同编号" min-width="100" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.serialNum" placeholder="请输入合同编号" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="createdBy" title="创建人" min-width="100" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.createdBy" placeholder="请输入创建人" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="signTime" title="签订时间" min-width="240" sortable />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.signTimeRange" 
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'signTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="gmtCreated" title="创建时间" min-width="240" sortable />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="false">
        <vxe-table-column field="fileUrl" title="附件地址" min-width="100" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.fileUrl" placeholder="请输入附件地址" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="false">
        <vxe-table-column field="code" title="UUID" min-width="100" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.code" placeholder="请输入UUID" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="false">
        <vxe-table-column field="branchCode" title="机构code" min-width="100" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.branchCode" placeholder="请输入机构code" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="false">
        <vxe-table-column field="partyCode" title="用户编码" min-width="100" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.partyCode" placeholder="请输入用户编码" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" fixed="right" min-width="130">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="详情" placement="top">
            <vxe-button type="text" @click="funcAdd('details',scope.row.code)">
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip v-if="!parentData.isDetail" class="item" effect="dark" content="编辑" placement="top">
            <vxe-button type="text" @click="funcAdd('edit',scope.row.code)">
              <i class="el-icon-edit" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip v-if="!parentData.isDetail" class="item" effect="dark" content="删除" placement="top">
            <vxe-button type="text" @click="funcDelete(scope.row.code)">
              <i class="el-icon-delete" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :page-sizes="Pagingconf"
      :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
      @page-change="handlePageChange"
    />

    <vxe-modal v-model="modelAddFlag" :title="modeladdTitle" width="500" height="420" resize>
      <compAdd ref="addRef" @fatherAddMethod="fatherAdd" @fatherCancelMethod="fatherCancel" />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import compAdd from "./components/shipmentContractAdd.vue";
import { getShipmentContrctList, delShipmentContract } from "@/api/shipment";

export default {
  name: "ShipmentContractList",
  components: {
    compAdd,
  },
  props: {
    parentData: {
      type: Object,
      default() {
        return {
          isDetail: false,
          areaOptions: [],
          goodsTypeList: [],
          typeOptions: [],
          vehicleDictList: [],
          bankOptions: [],
          receiverUserCodeOptions: [],
        };
      },
    },
  },
  data() {
    return {
      exportObj:{
        exportUrl:"/ntocc-basic-api/shipmentContract/exportShipmentContract",//导出接口
        name:'合同管理'
      },
      loading: false,
      tableData: [],
      modelAddFlag: false,
      modeladdTitle: "新增",
      copy: false,
      listQuery: {
        signTimeRange:'',
        gmtCreatedRange:'',
        partyCode: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
      },
    };
  },
  created() {
    this.listQuery.partyCode = this.$route.query.partyCode|| "";
    // this.findList();
  },
  methods: {
    findList() {
      this.loading = true;
      return new Promise((resolve) => {
        getShipmentContrctList(this.listQuery).then((response) => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.loading = false;
          resolve();
        });
      });
    },
    // 添加方法
    funcAdd(type,code) {
      this.modelAddFlag = true;
      this.modeladdTitle = type=="add"?"新增":type=="edit"?"编辑":"详情"
      this.$refs.addRef.getInfo(type,code);
    },
    // 删除方法
    funcDelete(codes) {
      this.$confirm("确认删除吗？")
        .then((_) => {
          delShipmentContract({ codes }).then((response) => {
            this.$message({ message: response.msg, type: "success" });
            this.findList();
          });
        })
        .catch((_) => {});
    },
    // 增加组件的父方法
    fatherAdd() {
      this.modelAddFlag = false;
      this.findList();
    },
    // 公共取消
    fatherCancel(modelFlag) {
      switch (modelFlag) {
        case "add":
          this.modelAddFlag = false;
          break;
        default:
      }
    },
  },
};
</script>
